import React from "react";
import { getValue } from "@utils/lodash";

function MoreAdminSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath id="clip-path5">
            <rect
              id="Rectangle_18188"
              data-name="Rectangle 18188"
              width="24"
              height="24"
              transform="translate(-14619 -8232)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_296"
          data-name="Mask Group 296"
          transform="translate(14619 8232)"
          clipPath="url(#clip-path5)"
        >
          <path
            id="admin_panel_settings_FILL0_wght300_GRAD0_opsz24"
            d="M18.931-11.911a1.535,1.535,0,0,0,1.125-.461,1.523,1.523,0,0,0,.463-1.121,1.523,1.523,0,0,0-.463-1.121,1.535,1.535,0,0,0-1.125-.461,1.535,1.535,0,0,0-1.125.461,1.523,1.523,0,0,0-.463,1.121,1.523,1.523,0,0,0,.463,1.121A1.535,1.535,0,0,0,18.931-11.911Zm0,3.164a3.079,3.079,0,0,0,1.514-.377,3.222,3.222,0,0,0,1.117-1.01,5.138,5.138,0,0,0-1.254-.538,5.1,5.1,0,0,0-1.376-.185,5.1,5.1,0,0,0-1.376.185,5.138,5.138,0,0,0-1.254.538,3.222,3.222,0,0,0,1.117,1.01A3.079,3.079,0,0,0,18.931-8.746ZM13.637-7.185a10.226,10.226,0,0,1-5.688-4.028A11.48,11.48,0,0,1,5.7-18.134V-24.2l7.941-2.961L21.578-24.2v5.976q-.371-.15-.778-.271a7.014,7.014,0,0,0-.81-.19V-23.1l-6.353-2.363L7.284-23.1v4.968a9.556,9.556,0,0,0,.4,2.737,10.81,10.81,0,0,0,1.094,2.5,9.927,9.927,0,0,0,1.667,2.085,8.313,8.313,0,0,0,2.1,1.476l.031-.01a5.774,5.774,0,0,0,.544,1.112,5.723,5.723,0,0,0,.759.965,1.134,1.134,0,0,0-.121.044,1.124,1.124,0,0,1-.121.044Zm5.294.02A4.6,4.6,0,0,1,15.557-8.55a4.568,4.568,0,0,1-1.391-3.361,4.568,4.568,0,0,1,1.391-3.361,4.6,4.6,0,0,1,3.374-1.385,4.6,4.6,0,0,1,3.374,1.385A4.568,4.568,0,0,1,23.7-11.911,4.568,4.568,0,0,1,22.305-8.55,4.6,4.6,0,0,1,18.931-7.164ZM13.637-17.4Z"
            transform="translate(-14621.695 -8202.836)"
            fill={
                getValue(props, `color`, "")
                  ? getValue(props, `color`, "")
                  : "#5f6368"
              }
          />
        </g>
      </svg>
    </div>
  );
}

export default MoreAdminSvgComponent;
